module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4D5Tx"))).then(() => parcelRequire('ikE14'));